<template>
	<div class="space-y-8 py-2 mt-4">
		<div class="space-y-4">
			<div class="flex flex-col space-y-4 w-full justify-end">
				<div class="flex w-full justify-between gap-x-4">
					<div class="text-start flex w-full justify-start font-semibold text-sm text-ihh-slate-gray m-auto">Country</div>
					<select
						v-model="consignment.country"
						@change="fetchStates"
						class="appearance-auto text-sm placeholder-ihh-gray focus:border-ihh-dark-salmon focus:outline-0 focus:shadow border border-ihh-slate-gray/10 shadow-ihh-dark-salmon text-ihh-midnight-gray rounded px-2 py-2 flex w-full bg-gradient-to-r from-ihh-pink/40 to-ihh-light-lavendar/40"
					>
						<option v-for="country in countries" :key="country.isoCode" :value="country.isoCode">{{ country.name }}</option>
					</select>
				</div>

				<div class="flex w-full justify-between gap-x-4">
					<div class="text-start flex w-full justify-start font-semibold text-sm text-ihh-slate-gray m-auto">State/Province</div>
					<select
						v-model="consignment.state"
						@change="fetchStates"
						class="appearance-auto text-sm placeholder-ihh-gray focus:border-ihh-dark-salmon focus:outline-0 focus:shadow border border-ihh-slate-gray/10 shadow-ihh-dark-salmon text-ihh-midnight-gray rounded px-2 py-2 flex w-full bg-gradient-to-r from-ihh-pink/40 to-ihh-light-lavendar/40"
					>
						<option disabled selected value="">Select a state</option>
						<option v-for="state in states" :key="state.name" :value="state.name">{{ state.name }}</option>
					</select>
				</div>

				<div class="flex w-full justify-between gap-x-4">
					<div class="text-start flex w-full justify-start font-semibold text-sm text-ihh-slate-gray m-auto">Zip/Postal Code</div>

					<input
						placeholder="Zip/Postal Code"
						v-model="consignment.zip"
						class="text-sm placeholder-ihh-gray/50 focus:border-ihh-dark-salmon focus:outline-0 focus:shadow border border-ihh-slate-gray/10 shadow-ihh-dark-salmon text-ihh-midnight-gray rounded px-2 py-2 flex w-full bg-gradient-to-r from-ihh-pink/40 to-ihh-light-lavendar/40"
						type="text"
					/>
				</div>
			</div>
			<div class="flex w-full justify-start">
				<button
					@click="getShippingEstimates"
					class="bg-ihh-dark-salmon hover:bg-ihh-salmon text-sm font-semibold px-3 py-2 flex justify-center items-center rounded-lg transform active:scale-90 transition duration-500 ease-in-out"
				>
					Estimate Shipping
				</button>
				<!-- <button @click="hideShipping" class="ml-20 border-none text-ihh-dark-salmon">Cancel</button> -->
			</div>

			<div v-if="checkout.shipping.fetching" class="w-full flex flex-col items-center py-12">
				<div class="italic text-sm mb-8">fetching shipping options...</div>
				<Spinner small="true" class="w-10 h-10"></Spinner>
			</div>

			<!-- Table Component with shipped Buttons -->
			<div v-if="checkout.shipping.shippingOptions" class="rounded mt-4 border-ihh-gray/50 overflow-hidden text-sm">
				<table class="text-ihh-midnight-gray w-full">
					<tbody>
						<tr
							v-for="(shipping, index) in checkout.shipping.shippingOptions"
							:key="index"
							@click="selectShipping(shipping)"
							:class="[
								'cursor-pointer hover:bg-ihh-gray/10',
								{
									'bg-gradient-to-r from-ihh-salmon/10 via-ihh-coral/20 to-ihh-salmon/10 hover:bg-ihh-salmon/10 font-semibold':
										checkout.shipping.selectedShipping?.id === shipping?.id,
									'': checkout.shipping.selectedShipping?.id !== shipping?.id,
								},
							]"
						>
							<td class="pl-6 mr-2">
								<div
									:class="[
										'items-center rounded-full',
										{
											'bg-ihh-dark-salmon ring-1 ring-ihh-dark-salmon ring-offset-4 w-3 h-3 ml-1':
												checkout.shipping.selectedShipping?.id === shipping?.id,
											'border border-ihh-gray w-5 h-5 bg-ihh-white text-ihh-midnight-gray/70': checkout.shipping.selectedShipping?.id !== shipping?.id,
										},
									]"
								/>
							</td>
							<td class="p-4 flex w-full justify-between gap-x-8 m-auto items-center">
								<!-- <div class="flex w-full">{{ formatShippingDescription(shipping?.description) }}</div> -->
								<div class="flex w-full">{{ formattedShipping(shipping?.description) }}</div>
								<div class="flex font-semibold">${{ shipping?.cost?.toFixed(2) }}</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div v-show="addressCompleted" class="flex w-full justify-start">
				<button @click="closeShipping" class="bg-ihh-dark-salmon hover:bg-ihh-salmon text-sm font-semibold px-3 py-2 flex justify-center items-center rounded-lg">
					Update Total
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'
import { useCheckoutStore } from '../../../stores/store.js'
import { Country, State } from 'country-state-city'
import helpers from '../../../helpers/checkout'

export default {
	inject: ['store'],
	data() {
		return {
			checkout: useCheckoutStore(),
			countries: [],
			states: [],
			consignment: {
				country: '',
				state: '',
				zip: null,
				email: this.store?.user?.email ? this.store.user.email : 'guest@inhishands.com',
			},
			addressCompleted: false,
			selectedShipping: {},
			shippingType: [],
		}
	},
	mounted() {},
	methods: {
		closeShipping() {
			this.$emit('updateShipping', false)
		},
		selectShipping(shipping) {
			this.checkout.selectShipping(shipping)
			console.log('waiting for hide shipping event')
			setTimeout(() => {
				console.log('hide shipping event triggered')
				this.$emit('hideShipping')
			}, 1000)
		},
		addressSubmit() {
			this.addressCompleted = !this.addressCompleted
		},
		updateTotal() {
			this.addressCompleted = false
		},
		fetchCountries() {
			console.log('fetching countries')
			this.countries = Country.getAllCountries()
			this.consignment.country = 'US'
		},
		fetchStates() {
			if (this.consignment.country) {
				console.log('Getting states....')
				this.states = State.getStatesOfCountry(this.consignment.country)
			}
		},
		formattedShipping(desc) {
			return helpers.formatShippingDescription(desc)
		},
		async getShippingEstimates() {
			console.log('BC cart ID: ', this.store.cart?.bcId)

			this.checkout.setFetchingShippingStatus(true)

			this.checkout.resetShipping()

			let consignment = {
				bcCartId: this.store.cart?.bcId,
				address: {
					email: this.consignment.email,
					state_or_province: this.consignment.state,
					country_code: this.consignment.country,
					postal_code: this.consignment.zip,
				},
			}

			let response = await axios.post(`${this.store.api}/controllers/bigCommerce/shipping`, consignment)
			if (response?.data?.success) {
				console.log('Shipping estimates retrieved....')
				console.log('shipping options: ', JSON.stringify(response.data.shippingOptions))
				// Sync with checkout state
				this.checkout.setShippingOptions(response.data.shippingOptions)
			}

			this.checkout.setFetchingShippingStatus(false)
		},
		hideShipping() {
			this.$emit('hideShipping')
		},
	},
	watch: {
		'consignment.country': 'fetchStates',
	},
	created() {
		this.fetchCountries()
		this.states = State.getStatesOfCountry('US')
	},
}
</script>
